import { ago } from "../lib/date";
import { useSyncStore } from "../stores/syncStore";
import { useTaskStore } from "../stores/taskStore";

export function StatusBar() {
  const stats = useTaskStore((s) => s.stats);
  const status = useSyncStore((s) => s.status);
  return (
    <footer className="flex h-7 items-center justify-between border-t border-border bg-card px-4 text-xs dark:border-border-dark dark:bg-card-dark">
      <div className="flex items-center gap-4">
        <span><span className="font-mono font-semibold text-text dark:text-text-dark">{stats.active}</span> <span className="text-muted dark:text-muted-dark">アクティブ</span></span>
        <span className="text-muted">·</span>
        <span><span className="font-mono font-semibold">{stats.completed}</span> <span className="text-muted dark:text-muted-dark">完了</span></span>
        <span className="text-muted">·</span>
        <span><span className="font-mono font-semibold">{status.pendingCount}</span> <span className="text-muted dark:text-muted-dark">pending</span></span>
      </div>
      <div className="text-muted dark:text-muted-dark">Notion {ago(status.lastSyncAt)}</div>
    </footer>
  );
}
